// extracted by mini-css-extract-plugin
module.exports = {"badge":"MenuDropdown_badge__ILtUb","menu_item":"MenuDropdown_menu_item__6v4Hl","menu_item_child":"MenuDropdown_menu_item_child__IlCxk"};